<template>
    <div class="position-r box">
        <!--banner-->
        <div class="index-banner" @click="goToUrl">
            <div class="f24 fw">欢迎使用</div>
            <div class="f24 fw"><span class="color-09">爱格汇</span>共享轮椅</div>
            <div class="pt5 flex-fs">
                <div class="mr8 photo-icon">
                    <img :src="headPhoto" alt="" class="head-img"/>
                </div>
                <span>{{userName}}</span>
            </div>
        </div>
        <div class="flexJC p15">
            <div class="">
                <div class="content-box">
                    <div class="text-center">
                        {{cabinetInfo && cabinetInfo.cabinet.placeName}}
                    </div>
                    <h3 class="text-center fw f18 pt5">
                        设备通讯异常或者订单状态异常
                    </h3>
                    <div class="pt10">
                        <div class="flexJC-sb pb10">
                            <span>设备名称：</span>
                            <span>{{`${cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.cabinetName||''}`}}</span>
                        </div>
                        <div class="flexJC-sb pb10">
                            <span>设备编号：</span>
                            <span>{{`${cabinetInfo && cabinetInfo.cabinet.qrCode}`}}</span>
                        </div>
                        <div class="pt10">
                            <h4>为您带来的不便我们深表歉意</h4>
                            <p class="pt5">请联系客服为您解决</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="p15  flexJC alignItem">
            <button class="btn-lx btn-lx-width mb20" :disabled="isDisabled == true" :class="isDisabled === true ? 'unSubmit' : 'btn-width'" @click="getOpenDor">刷新查看</button>
            <a href="tel:400-688-9528" class="btn-lx btn-lx-width">联系客服</a>
        </div>
        <div class="shade" v-if="isLoading">
            <div class="flexJC alignItem showLoading">
                <img src="../../static/images/Spinner_1.gif" alt="" class="icon_loading"/>
            </div>
        </div>
    </div>
</template>

<script>
    import wxServ from '../service/wxServ'
    import cache from '../service/cacheServ'
    import userServ from '../service/userServ'
    import mintUi from '../lib/mint-ui'
    import cabinetServ from '../service/cabinetServ'
    import preventBack from 'vue-prevent-browser-back'
    export default {
        mixins: [preventBack], //禁止返回上一页
        data () {
            return {
                headPhoto: '/static/images/touxiang@2x.png',
                userName: '',
                isLoading: false,
                cabinetName: null,
                qrCode: null,
                placeName: null,
                cabinetInfo: null,
                isDisabled: false,
            }
        },
        created () {
            let userInfo = cache.get('user');
            let qrCode = this.$route.query.qrCode;
            if (userInfo) {
                this.userName = userInfo.customerName;
                this.headPhoto = userInfo.headImgUrl ? userInfo.headImgUrl: '/static/images/touxiang@2x.png'
                this.qrCode = qrCode
                this.cabinetInfo = cache.get('cabinetInfo')
            }
           this.getOpenDor('1')
        },
        methods: {
            // 获取设备状态
            getCabinetSta (qrCode){
                this.isLoading = true
                cabinetServ.getCabinetStatus(qrCode).then(res => {
                    this.isLoading = false
                    if (res.code === '200') {
                        this.cabinetInfo = res.data
                    } else {
                        mintUi.Toast({
                            message: res.message,
                            position: 'bottom'
                        })
                    }
                })
            },
            goToUrl () {
                window.location.href ='https://www.aigehui028.com/'
            },
            getOpenDor(isSys) {
                if (this.isDisabled == true) return;
                let cabinetNo = cache.get('cabinetInfo').cabinet.cabinetNo;
                let customerWxId = cache.get('user').openId;
                let orderNo = this.$route.query.orderNo;
                let qrCode = cache.get('cabinetInfo').cabinet.qrCode;
                this.isLoading = true;
                this.isDisabled = true;
                cabinetServ.getIsOpenDoor(cabinetNo,orderNo,customerWxId,qrCode)
                        .then( res => {
                            this.isLoading = false
                            if (res.code === '200') {
                                if (res.data.cabinetStatus == 'online'){ // 在线
                                    if (!res.data.orderStatus) {
                                        mintUi.Toast({
                                            message: '订单不存在，如有疑问请联系管理员',
                                            position: 'bottom',
                                            duration: 4000,
                                         });
                                         setTimeout(() => {
                                           this.isDisabled = false;
                                         }, 4000);
                                    } else {
                                        if(res.data.orderStatus == '1'&&res.data.doorId){ // 已支付
                                            if (parseInt(res.data.doorId) > 0){// 已支付 门已开
                                                this.$router.push({path: '/openSuccess', query: {qrCode: qrCode,orderNo:orderNo}})
                                            } else {// 已支付 门未开 去开门
                                               this.$router.push({ path: '/openDoorUnSuccess', query: { qrCode: qrCode, orderNo: orderNo } })
                                            }
                                        }else if(res.data.orderStatus == '2'&&res.data.doorId) {// 已借出
                                            this.$router.push({path: '/openSuccess', query: {qrCode: qrCode,orderNo:orderNo}})
                                        } else {// 其他状态去异常页面
                                          if(isSys=='1'){
                                            this.isDisabled = false;
                                          }else{
                                            mintUi.Toast({
                                                message: '请再次刷新查看或联系管理员',
                                                position: 'bottom',
                                                duration: 4000,
                                             });
                                             setTimeout(() => {
                                               this.isDisabled = false;
                                             }, 4000);
                                          }
                                        }
                                    }
                                } else {
                                  if(isSys=='1'){
                                    this.isDisabled = false;
                                  }else{
                                    mintUi.Toast({
                                        message: '请再次刷新查看或联系管理员',
                                        position: 'bottom',
                                        duration: 4000,
                                         });
                                         setTimeout(() => {
                                           this.isDisabled = false;
                                         }, 4000);
                                  }
                                }
                            } else {
                              if(isSys=='1'){
                                this.isDisabled = false;
                              }else{
                                mintUi.Toast({
                                    message: res.message,
                                    position: 'bottom',
                                    duration: 4000,
                                    });
                                    setTimeout(() => {
                                        this.isDisabled = false;
                                    }, 4000);
                              }
                            }
                        })
            },
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
    @import '../less/_var.less';
    @import '../less/index.less';
    .index-banner{
        padding: 26px 25px 0 25px;
        text-align: left;
        color: #fff;
    }
    .pt5{
        padding-top: 5px;
    }
    .loadingImg{
        width: 100px;
        height: 100px;
    }
    .loading-con{
        width: 70%;
        margin-left: -35%;
    }
    .photo-icon{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        -webkit-border-radius: 50%;
    }
    .photo-icon img{
        width: 100%;
        height: 100%;
    }
    .userInfo{
        position: absolute;
        left: 90px;
        top:15px;
        right: 16px;
    }
    .icon_lb{
        background: url("../../static/images/icon_position.png") no-repeat;
        background-size: 100% 100%;
        width: 14px;
        height: 16px;
    }
    .icon-fy{
        background: url("../../static/images/icon_fy.png") no-repeat;
        background-size: 100% 100%;
        width: 22px;
        height: 22px;
    }
    .mt-3{
        margin-top: -2px;
    }
    .icon-sb{
        background: url("../../static/images/icon_sb.png") no-repeat;
        background-size: 100% 100%;
        width: 22px;
        height: 22px;
    }
    .icon_loading{
        width: 60px;
        height: 60px;
    }

    .head-img{
        border-radius: 50%;
        -webkit-border-radius: 50%;
    }
    .unSubmit {
      background-color: #808080;
      color: #fff;
      border-color: #808080;
    }
</style>



// WEBPACK FOOTER //
// src/pages/no-normal.vue